import { Toolbar } from '@base-ui/react/toolbar'
import { twMerge } from 'tailwind-merge'

interface ActionPopoverSeparatorProps {
  className?: string
}

function ActionPopoverSeparator({ className }: ActionPopoverSeparatorProps) {
  return <Toolbar.Separator className={twMerge('bg-border mx-1 h-[16px] min-w-px', className)} />
}

export { ActionPopoverSeparator }
